import { CalendarDto } from 'src/dtos/calendar/calendarDto';

// 날짜 관련 유틸리티
export const dateUtils = {
  // 월의 첫날과 마지막날 계산
  getMonthDateRange: (year: number, month: number) => {
    const startDate = `${year}-${String(month).padStart(2, '0')}-01`;
    const lastDay = new Date(year, month, 0).getDate();
    const endDate = `${year}-${String(month).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
    return { startDate, endDate };
  },

  // 캘린더 그리드용 날짜 배열 생성 (5주)
  generateCalendarDates: (currentDate: Date) => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());
    const dates = [];
    const currentDateIterator = new Date(startDate);
    for (let i = 0; i < 35; i++) { // 5주 x 7일 = 35일
      dates.push(new Date(currentDateIterator));
      currentDateIterator.setDate(currentDateIterator.getDate() + 1);
    }
    return dates;
  },

  // 오늘 날짜인지 확인
  isToday: (date: Date) => {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  },

  // 현재 월의 날짜인지 확인
  isCurrentMonth: (date: Date, currentMonth: number) => {
    return date.getMonth() === currentMonth;
  },

  // 날짜 포맷팅
  formatCurrentDate: (date: Date) => {
    return `${date.getFullYear()}년 ${date.getMonth() + 1}월`;
  },

  // 날짜를 YYYY-MM-DD 형식으로 변환
  toDateString: (date: Date) => {
    return date.toISOString().split('T')[0];
  }
};

// 이벤트 관련 유틸리티
export const eventUtils = {
  // 특정 날짜의 이벤트 필터링
  getEventsForDate: (events: any[], date: Date) => {
    // 로컬 타임존 기준 YYYY-MM-DD
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const localDateStr = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
    return events.filter(event => {
      if (typeof event.systemDay === 'string') {
        return event.systemDay.substring(0, 10) === localDateStr;
      }
      return false;
    });
  },

  // 특정 월의 이벤트 필터링
  getEventsForMonth: (events: CalendarDto[], year: number, month: number) => {
    return events.filter(event => {
      const eventDate = new Date(event.systemDay);
      return eventDate.getFullYear() === year && eventDate.getMonth() === month;
    });
  },

  // 휴일 이벤트만 필터링
  getHolidayEvents: (events: CalendarDto[]) => {
    return events.filter(event => event.holidayYn === 'Y');
  }
};

// 검색 조건 관련 유틸리티
export const searchUtils = {
  // API 검색 파라미터 생성
  createSearchParams: (year: number, month: number, compCd?: string) => {
    const { startDate, endDate } = dateUtils.getMonthDateRange(year, month);
    const params: any = {
      startDate,
      endDate,
      holidayYn: 'Y'
    };
    
    if (compCd) {
      params.compCd = compCd;
    }
    
    return params;
  }
};

// 엑셀 내보내기 유틸리티(미사용)
export const exportUtils = {
  // CSV 데이터 생성
  createCSVContent: (events: CalendarDto[]) => {
    const headers = ['회사코드', '날짜', '휴일여부', '휴일명', '휴일타입', '비고'];
    const rows = events.map(event => [
      event.compCd,
      event.systemDay,
      event.holidayYn,
      event.holidayName,
      event.holidayType,
      event.remark
    ]);
    
    return [headers, ...rows].map(row => row.join(',')).join('\n');
  },

  // CSV 파일 다운로드
  downloadCSV: (csvContent: string, filename: string) => {
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}; 